import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.$auth.check() && 
    (
      !['Err404', 'NewExecution', 'ContinueExecution', 'ReviewExecution', 'ExecuteTask', 'ContinueTask'].includes(_vm.$route.name) && _vm.$route.name
    ) && (
      !['/dashboard?tv=true'].includes(_vm.$route.fullPath)
    ))?_c(VAppBar,{attrs:{"id":"core-app-bar","app":"","color":"background","dense":"","dark":_vm.dark,"height":"60","flat":_vm.flat}},[_c(VAppBarNavIcon,{on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}}),_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.title))]),_c(VSpacer),_c(VToolbarItems,[(_vm.oneUser && _vm.use_white_label)?_c('theme-change'):_vm._e(),_c('menu-solution')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }